"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class SessionServiceLive {
    setCurrentSessionId(sessionId) {
        localStorage.setItem("sessionId", sessionId);
    }
    removeCurrentSessionId() {
        localStorage.removeItem("sessionId");
    }
    createSession(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { userId } = params;
            const response = yield HttpProvider_1.httpProvider.post("session/create-session", {
                userId,
            });
            this.setCurrentSessionId(response.data.payload.sessionId);
            return response.data;
        });
    }
    revokeSession() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post("session/revoke-session");
            this.removeCurrentSessionId();
            return response.data;
        });
    }
    updateLastAccess(lastAccess) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch("session/update-session", {
                lastActive: lastAccess,
            });
            return response.data;
        });
    }
}
exports.SessionServiceLive = SessionServiceLive;
//# sourceMappingURL=SessionServiceLive.js.map